<template>
  <section class="scenario-game d-flex">
    <div class="dragger d-flex items-center justify-center ">
      <b-icon-list class="h3 mb-0"></b-icon-list>
    </div>
    <div class="order d-flex items-center justify-center ">
      <p>{{index}}</p>
    </div>
    <div class="game p-4 d-flex items-center">
    
      <p class="mr-2">{{currentGame.name}}</p>
      <span v-if="currentGame.title" class="mr-2">-</span>
      <p class="mr-2">{{currentGame.title}}</p>
      <span v-if="currentGame.type && currentGame.type.name" class="mr-2">-</span>
      <p class="mr-2">{{currentGame.type && currentGame.type.name}}</p>
      <p v-if="currentGame.type && ['quiz_simple', 'true_false'].includes(currentGame.type.slug)"> <span class="mr-2">-</span> {{currentGame.questions.aggregate.count}} questions</p>
      <button
          type="button"
          class="twn-button text-sm ml-auto"
          @click="selectGame"
        >
          Modifier l'activité
        </button>
    </div>
    <div class="remove d-flex items-center justify-center" @click="$emit('remove-game', node.id)">
      <b-icon-x></b-icon-x>
    </div>


  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ['node', 'index'],
  computed: {
    ...mapState({
        gameList: state => state.Games.list,
    }),
    currentGame() {
      return this.gameList.find(game => game.id === this.node.node_content) || { name: '~ Activité sans titre ou supprimé ~' }
    }
  },
  methods: {
    selectGame() {
      // Use custom event to make them available outside of the current Vue.js context 
      this.$emit('select-game', this.node)
    },
  },
}
</script>

<style lang="scss">
  .scenario-game {
    width: 100%;
    .dragger, .order {
      width: 4%;
    }
    .order {
      background: #FAEFF0;
    }
    .remove{
      width: 4%;
      background: #DC9799
;
    }
    .game {
      width: 88%;
    }
  }
</style>